import { CardContent, Typography, Grid } from '@material-ui/core';
import { Field } from 'formik';
import { TextField } from 'formik-material-ui';


let Contacts = () => {
    return (
        <CardContent>
            <Typography variant="h4">Contacts</Typography>
            <Field
                label="Email"
                name="email"
                type="email"
                component={TextField}
                fullWidth
                margin="normal"
            />
            <Grid container spacing={1} alignItems="flex-end">
                <Grid item xs={6}>
                    <Field
                        label="Phone"
                        name="phone"
                        component={TextField}
                        fullWidth
                        margin="normal"
                    />
                </Grid>
                <Grid item xs={6}>
                    <Field
                        label="Fax"
                        name="fax"
                        component={TextField}
                        fullWidth
                        margin="normal"
                    />
                </Grid>
            </Grid>
        </CardContent>
    )
}


export default Contacts;